import { render, staticRenderFns } from "./packagesForm.vue?vue&type=template&id=32bfad80&scoped=true"
import script from "./packagesForm.vue?vue&type=script&lang=js"
export * from "./packagesForm.vue?vue&type=script&lang=js"
import style0 from "./packagesForm.vue?vue&type=style&index=0&id=32bfad80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bfad80",
  null
  
)

export default component.exports